<ng-container *transloco="let t;">

  <p-dialog [header]="t('common.labels.filter')" [(visible)]="visible" (onHide)="emitOnHide()" [style]="{width: '50vw'}">
    <p>{{ t('reportings_date_filter.labels.select1') }}</p>
    <div class="p-mb-4 export-tags">
      <span class="p-mr-2 p-mb-2" *ngFor="let period of periods">
        <p-tag [value]="t('reportings_date_filter.periods.' + period)" [ngClass]="{inactive: period !== actualPeriod}" (click)="selectPeriod(period)"></p-tag>
      </span>
    </div>
    <p>{{ t('reportings_date_filter.labels.select2') }}</p>
    <div class="p-grid p-fluid">
      <div class="p-col">
        <app-form-control [cid]="'start'" [control]="form.get('start')" [type]="'date'" [showTime]="false" [label]="t('common.labels.start')" (changed)="selectPeriod(null)"></app-form-control>
      </div>
      <div class="p-col">
        <app-form-control [cid]="'end'" [control]="form.get('end')" [type]="'date'" [showTime]="false" [label]="t('common.labels.end')" (changed)="selectPeriod(null)"></app-form-control>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton (click)="onCancel()" type="button" class="p-button-secondary p-button-outlined" aria-label="{{ t('common.labels.cancel') }}" [label]="t('common.labels.cancel')"></button>
      <button #select pButton (click)="onSelect()" type="button" aria-label="{{ t('common.ok') }}" [label]="t('common.ok')" autofocus></button>
    </ng-template>
  </p-dialog>

</ng-container>
